import type { ODSIconName } from '@telekom-ods/react-icons';
import { ODSAvatar, ODSColumn, ODSText } from '@telekom-ods/react-ui-kit';
import { Link } from 'react-router';
import './SideNavigation.css';

interface NavItemProps {
  theme: string;
  label: string;
  to: string;
  icon: ODSIconName;
  collasped?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ theme, label, to, icon, collasped }) => {
  return (
    <Link
      to={to}
      style={{
        textDecoration: 'none',
        color: theme === 'light' ? 'black' : 'white',
        height: !collasped ? '40px' : '80px',
        display: 'block',
        position: 'relative',
      }}
    >
      <ODSColumn
        className={collasped ? 'link-content link-content-col' : 'link-content link-content-row'}
      >
        <ODSAvatar
          icon={icon}
          name='theme-toggle'
          showBackground
          size='medium'
          variant='icon'
        />
        <ODSText
          as='h4'
          style={{
            margin: 0,
          }}
        >
          {label}
        </ODSText>
      </ODSColumn>
    </Link>
  );
};

export default NavItem;
